import React from 'react';
import { HashLink } from 'react-router-hash-link';
import {  useLocation } from 'react-router-dom';
import NamingLogo from '../../images/naming.gif';
import BackAndHomeButton from "../../images/back_home_button.png";
import HelpBreadCrumb from "../../images/help_breadcrumb.gif";
import ButtonNewFolder from "../../images/button_new_folder.gif";
import Header from '../common/Header/Header';
import Footer from '../common/Footer/Footer';
import TopNav from '../common/Banner/TopNav';
import CreateNewFolderPopUp from '../../images/create_new_folder_popup.png';
import UploadDownloadButton from '../../images/upload_download_button.png';
import BulkFileUploader from '../../images/bulk_file_uploader.png';
import BulkFileUploadInprogress from '../../images/bulk_file_upload_inprogress.png';
import FileUploadClose from '../../images/file_upload_close.png';
import DownloadFilesPopup from '../../images/download_files_popup.png';
import UnzipFile from '../../images/unzip_file.png';
import UnZipFilePopup from '../../images/unzip_file_popup.png';
import SmsProtection from '../../images/sms_protection.png';
import SmsProtectionSaveChanges from '../../images/sms_protection_save_changes.png';
import SmsProtectionLock from '../../images/sms_protection_lock.png';
import PushLive from '../../images/push_live.png';
import PushLivePopUp from '../../images/push_live_popup.png';
import PushLiveURL from '../../images/push_live_url.png';
import ListOfFiles from '../../images/list_of_files.png';
import ViewingFiles from '../../images/viewing_files.png';
import RenameFile from '../../images/rename_file.png';
import RenameFilePopUp from '../../images/rename_file_popup.png';
import DeleteFile from '../../images/delete_file.png';
import DeleteFilePopUp from '../../images/delete_file_popup.png';
import HelpBulkrenameBtn from '../../images/help_bulkrename_btn.png'
import HelpConfirmRename from '../../images/help_ConfirmRename.png'
import HelpEditablePopup from '../../images/help_EditablePopup.png'
import HelpRenameHighlights from '../../images/help_RenameHighlights.png'
import Helplivedownload from '../../images/help_livedownload.png'
import HelpUnzipsuccess from '../../images/help_unzipfilesexists.png'
import HelpUnZipReplace from '../../images/Help_UnZipReplace.png';
import ViewSoftDeletedFiles from '../../images/view_soft_deleted_files.png';
import DeletedItemsDashboard from '../../images/deleted_items_dashboard.png';
import DeletedItemsBulkSelect from '../../images/deleted_items_bulk_select.png';
import RestoreConfirmationPopup from '../../images/restore_confirmation_popup.png';
import RestoredItemsDashboard from '../../images/restored_items_dashboard.png';
import DuplicateSoftDeletePopup from '../../images/duplicate_soft_delete_popup.png';  
import SoftDeleteFilePopUp from '../../images/SoftDeleteFilePopUp.png';  
import CancelOnlyPopup from '../../images/CancelOnlyPopup.png';  //Pending
import RenameSoftDeletedConflict from '../../images/rename_soft_deleted_conflict.png';
import BulkRenameSoftDeletedConflict from '../../images/bulk_rename_soft_deleted_conflict.png';
 
 
const MyHelp = ({}) => {
    const userName = 'Mediadev.pearson.com - Help';
    const location = useLocation();
    const currentPath = location.pathname;
 
 
    return (
      <>
        <Header title={userName}/>
        <body>
        <TopNav  title={userName} currentPath={currentPath} />
 
        <span className="spacer"><br/><br/></span>
 
            <table role="presentation" border="0" width="90%" cellSpacing="1" cellPadding="2" className="myTable" align="center">
            <tr align="right" valign="top">
                <td className="helpGreen" align="right">
               
                <table role="presentation" border="0" width="65%" cellSpacing="0" cellPadding="5" align="right">
                    <tr align="left" valign="top">
                        <td align="left" valign="top" colspan="3"><font size="+1" color="#333333">Using the MediaServer Content Propagation Utility</font></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top" rowspan="5">&nbsp;</td>
                        <td align="left" valign="top"><HashLink to="#overview">MediaServer Overview</HashLink></td>
                        <td align="left" valign="top"><HashLink to="#sms">Applying SMS Protection</HashLink></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top"><HashLink to="#filenamingpolicy">File Naming Policy</HashLink></td>
                        <td align="left" valign="top"><HashLink to="#pushing">Pushing Files</HashLink></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top"><HashLink to="#navigation">Navigating the MediaServer</HashLink></td>
                        <td align="left" valign="top"><HashLink to="#viewing">Viewing Files</HashLink></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top"><HashLink to="#folders">Creating a New Folder</HashLink></td>
                        <td align="left" valign="top"><HashLink to="#renaming">Renaming Files</HashLink></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top"><HashLink to="#uploading">Uploading / Downloading Files</HashLink></td>
                        <td align="left" valign="top"><HashLink to="#deleting">Deleting Files</HashLink></td>
                    </tr>
                    <tr align="left" valign="top">
                        <td align="left" valign="top" rowspan="5">&nbsp;</td>
                        <td align="left" valign="top"><HashLink to="#unzipping">Unzipping Files</HashLink></td>
                          <td align="left" valign="top"><HashLink to="#bulkrenaming">Bulk Renaming Files</HashLink></td>                        
                    </tr>
                </table>
               
               
                </td>
            </tr>
        </table>
 
        <span className="spacer"><br/><br/><br/></span>
 
        <section id="overview">
            <table role="presentation" border="0" width="90%" cellSpacing="1" cellPadding="2" align="center" summary="MediaServer Overview">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">MediaServer Overview</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">
                        <p>The Pearson Media Server is a hosting facility specifically designed to house media and content files to be used in your online courses allowing users the ability to upload, preview and deliver content efficiently and reliably. Users can upload their content through to the staging area, manage their content through the Content Propagation Utility and push it live. Currently about 200 million assets totaling about 30 TB content are stored and delivered through the Media Server with a peak usage of 500+ million hits during a busy back to school month of September.</p>
                        <p>
                        The Media Server consists of two servers: a development server and a live server.
                        </p>
                        <p> <strong>Development:</strong>  <a href='https://mediaconsole.pearson.com/mdc/auth/media//' target='_blank'>https://mediaconsole.pearson.com/mdc/auth/media//</a><br/>
 
                        <strong>Production:</strong> https://media.pearsoncmg.com</p>
 
                        <p>Files are uploaded to the development server, and then "pushed" to the live server. You may only link to files on the live server. </p>
 
                         <p>EXE files are permitted, but may not be executable and must be zipped.</p>
 
                        <p>
                        Scripting languages for web development and Server side Includes will not work in Media Server and are not allowed.
                        </p>
                       
                       </td>
                </tr>
               
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="filenamingpolicy">
            <table role="presentation" border="0" width="90%" cellSpacing="1" cellPadding="2" align="center" summary="File Naming Policy">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">File Naming Policy</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">
                        <p>
                        The File Naming Policy disallows the use of spaces as a delimiter in file and folder naming conventions.
                        </p>
                       
                        <p>
                        The File Naming Policy limits characters in file names by listing 5 acceptable types of characters. All other characters are banned. Specifically allowed are the following:
                        </p>
                        <ul>
                            <li>&nbsp;  &#8226; alphanumeric characters (a-z, 0-9)</li>
                            <li>&nbsp;  &#8226; underscores</li>
                            <li>&nbsp;  &#8226; hyphens</li>
                            <li>&nbsp;  &#8226; ~ (tilde)</li>
                            <li>&nbsp;  &#8226; a single period/full point before the file extension only</li>
                        </ul>
                        <p>
                        <strong> Delimiter Recommendation - </strong>Delimiters represent one of various means to specify boundaries in a data stream. The File Naming Policy recommends using the following to delimit file and folder names:
                        </p>
                        <ul>
                            <li>&nbsp;  &#8226; Underscores. Example: file_naming_policy.doc</li>
                        </ul>
                        <p>
                        <strong> Upper/Lowercase Recommendation - </strong>Some systems treat capital and lowercase letters differently:
                        </p>
                        <ul>
                            <li>&nbsp;  &#8226; Most systems treat case the same, such that Pearson.jpg overwrites pearson.jpg</li>
                            <li>&nbsp;  &#8226; A few systems allow characters of different cases to coexist, such that Pearson.jpg and pearson.jpg are two different files.</li>
 
                        </ul>
                        <p>If you are creating a new course directory, each course on the Media Server must be titled with a course name, following the filename convention below, and no spaces, 8-bit characters are allowed.<br/>
                        <center><img src={NamingLogo} alt="Naming Convention" width="537" height="71" hspace="0" vspace="0" border="0" />
                        <p>Example: hss_smith_accounting_10e <br/>Example: hss_myanthrolibrary</p></center>
                        </p>
                       </td>
                </tr>
               
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="navigation">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Navigating the MediaServer">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Navigating the MediaServer</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>After you have successfully logged onto the Media Server, you will be situated at the top level of your imprint. If you will be uploading files to an existing folder, navigate to that folder by clicking the folder name.</p>
            <p>Clicking the <strong>back button </strong>will bring you up one level in the directory structure and clicking the <strong>home button</strong> will bring you to the top level of your imprint.</p>
            <center><img src={BackAndHomeButton} alt="back button" width="150" height="60" hspace="0" vspace="0" border="0" align="absmiddle"/></center>
            <p>You can also navigate by clicking the folder names in the  <strong>Current Location</strong> bread crumb trail:</p>
            <center><img src={HelpBreadCrumb} alt="breadcrumb trail" width="321" height="43" hspace="0" vspace="10" border="0" /></center></td>
                </tr>
            </table>
        </section>
 
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="folders">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Creating a New Folder">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Creating a New Folder</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">
                        <p>To create a new folder on the Media Server, simply click the  <strong>new folder</strong> button located in the upper left-hand of your screen.</p>
                        <center><img src={ButtonNewFolder} alt="new folder" width="54" height="48" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    <p> A new window will launch, prompting you to enter a name for the folder in the text field. Click the <strong>Create Folder</strong> button and your main browser window will refresh, displaying the new folder you have just created.</p>
                    <center><img src={CreateNewFolderPopUp} alt="new folder" width="700 " height="240" hspace="0" vspace="0" border="0" align="absmiddle" /></center></td>
 
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="uploading">
 
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Uploading Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Uploading / Downloading Files</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">
                    <center><img src={UploadDownloadButton} alt="upload download button" width="120" height="60" hspace="0" vspace="0" border="0" align="absmiddle"/></center>
                    <p>The Media Server allows users to upload as many files in one pass of any size.  To begin uploading files, navigate to the directory where you would like to begin posting files. Next, click the <strong>upload</strong> button located in the upper left-hand corner.</p>
                    <p>The <strong>Bulk File Uploader</strong> window will open. Drag and drop files or click to select files. Once files are selected, click the <strong>“Upload Files”</strong> button to begin the upload process. </p>
                    <center><img src={BulkFileUploader} alt="Bulk File Uploader" width="700 " height="300" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    <p>A progress bar will appear in the bottom frame of the <strong>File Uploader</strong> window indicating the status of your upload. </p>
                    <center><img src={BulkFileUploadInprogress} alt="Bulk File Upload Inprogress" width="700 " height="470" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                    <p>When the upload has completed, click <strong>"Close"</strong> to return to your main browser window.</p>
                    <center><img src={FileUploadClose} alt="Bulk File Upload Close" width="700" height="250" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                    <p>To download files, click on the download button next to the upload button.  You have the option select files and folders. Simply click on the select button on the left side to begin downloading., and the files will be zipped once downloaded. </p>
                    <center><img src={DownloadFilesPopup} alt="Download Files PopUp" width="700 " height="550" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="unzipping">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Unzipping Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Unzipping Files</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>If you choose to upload a ZIP file containing multiple files and folders, you may do so in the File Uploader window. It may be more beneficial to ZIP your entire directory or group of directories and files and upload the single ZIP file. After you have uploaded your ZIP file, an unzip icon will appear under the unzip column to the right of your file name. </p>
                    <center><img src={UnzipFile} alt="UnZip File" width="700 " height="50" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                        <p>Clicking the unzip icon will prompt the following message.</p>
                        <center><img src={UnZipFilePopup} alt="UnZip File Popup" width="700 " height="200" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                    </td>
                </tr>
 
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>When you unzip a ZIP folder:</p>
                        <p>1. The system checks if any <strong>files</strong> in the destination have the same name as those in the ZIP file.
                        If a conflict is found,
                        a confirmation popup will appear asking if you want to replace the existing files/folders. </p>
                        <center><img src={HelpUnzipsuccess} alt="UnZip File" width="700 " height="280" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <br/>
                        <p>2. The system checks if any <strong>folders</strong> in the destination have the same name as those in the ZIP file.
                        If a conflict is found,
                        a confirmation popup will appear asking if you want to replace the existing directory. </p>
                        <center><img src={HelpUnZipReplace} alt="UnZip File" width="700 " height="240" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                       <p>Click <strong>"Unzip"</strong> to proceed. Depending on the size and complexity of the ZIP file, the unzipping process could take a few minutes to complete. Once the unzipping process is complete and you have check to see that all of your files have been properly unloaded, you may delete the original ZIP file (see <strong>Deleting Files</strong> below).</p>
 
                    </td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="sms">
 
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Applying SMS Protection">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Applying SMS Protection</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>You may apply SMS protection to any file or folder on the Media Server. To do so, click the <strong>open lock</strong> icon to the left of the file/folder name. </p>
                        <center><img src={SmsProtection} alt="Sms Protection" width="500 " height="40" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <p>This will launch the SMS Configuration window below. You have the option to enable or disable protection.  Complete the SMS configuration by entering the required information and click to <strong>“Save Changes”</strong> to close the window. </p>
                        <center><img src={SmsProtectionSaveChanges} alt="Sms Protection Save Changes" width="700 " height="500" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <p>Enabling protection will show a locked icon status and disabling protection will show unlocked icon. </p>
                        <center><img src={SmsProtectionLock} alt="Sms Protection Lock" width="500 " height="70" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <p>In order for the SMS configuration to apply to the live server, you must push the file/folder (see Pushing Files section below). Once SMS has been applied to a folder, all items within that folder will inherit those SMS settings. You may override those inherited setting for any file/folder by simply clicking the locked icon.</p></td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="pushing">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Pushing Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Pushing Files</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>To promote a file or directory to the live server, click the <strong>push</strong> button located to the far right of your file or folder name.</p>
                        <center><img src={PushLive} alt="Push Live" width="700 " height="110" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <p>A confirmation window will pop up asking if you want to push the fille(s) live, click OK.</p>
                        <center><img src={PushLivePopUp} alt="Push Live PopUp" width="500 " height="150" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                        <p>Keep in mind you can promote entire directories as well as individual files. <strong>Important note:</strong> if you have created a new course directory folder for the first time you promote to the live server you must "push" the entire directory. Otherwise, if you promote a subdirectory or files inside that folder, it will not transfer to the live server.</p>
 
                        <p><strong>Warning! </strong>If you promote the entire course folder/directory, it will overwrite all files on the live server.</p>
 
                        <p>For instance, if you have a folder titled hss_arnett_lifedevelopment_3e, on the development server that contains no files, but you already have the same folder on the live server that does contains files, pushing the empty folder from the development server will overwrite and erase the files on the live server.</p>
 
                        <p>Once you have successfully pushed a file or folder, you will see the confirmation message in the upper right of the window. This message will also contain the live URL to the file (or folder) that you may copy to paste for use in your online courses. </p>
                        <center><img src={PushLiveURL} alt="Push Live URL" width="500 " height="100" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                        <p>Also, the system automatically generates Live URLs for the selected folder and all its subfolders and files. These URLs are then exported and downloaded into an Excel file.
                      </p>
               
                <tr>
                     <td colspan="2"><h5> URL Generation</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                     <p>                  
                        The system will generate Live URLs for the selected folder, all subfolders and files under it.
                        If there are previously pushed folders or files, the export will include both old and new Live URLs.
                     </p>
                     <p>Note : Export file will be generated if the folder has more than one file or folder </p>
                    </td>
                </tr>
                <tr>
                     <td colspan="2"><h5>Export and Download</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                     <p>
                        Once all Live URLs are generated, an Excel file containing the URLs will be created.
                        The file will download automatically to your system.
                    </p>
                        <center><img src={Helplivedownload} alt="Push Live URL" width="500 " height="100" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>  
                <tr>
                     <td colspan="2"><h5>Review and Select</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                     <p>
                        Open the downloaded Excel file.
                        Review the list of Live URLs.
                        Select the URLs you need for your workflow or sharing.
                    </p>
                    </td>
                </tr>  
 
                </td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="viewing">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Viewing Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Viewing Files</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>To view any file on the Media Server, simply click on the file name to launch a new browser window containing the file. </p>
                    <center><img src={ListOfFiles} alt="List Of Files" width="700 " height="150" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    <p>Next, using your browser's menu options, view the address bar to see the Media Server development URL.</p>
                    <center><img src={ViewingFiles} alt="Viewing Files" width="700 " height="500" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    <p>Change the <strong>“https://mediaconsole.pearson.com/mdc/preview/”</strong> URL to <strong>“https://media.pearsoncmg.com”</strong> to access the live URL of the file (assuming you have previously <u>pushed</u> the file).</p></td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="renaming">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Renaming Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Renaming Files</td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>To rename a file or folder, click the <strong>rename</strong> icon located to the right of the file/folder under the rename column.</p>
                    <center><img src={RenameFile} alt="Rename File" width="700 " height="100" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    <p>A new browser window will spawn showing the previous file/folder name in the text field. Rename your file or folder, then click the <strong>Rename</strong> button. Your main browser window will refresh, displaying the newly named file or folder.</p>
                    <center><img src={RenameFilePopUp} alt="Rename File PopUp" width="700 " height="250" hspace="0" vspace="0" border="0" align="absmiddle" /></center></td>
                </tr>
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
        <section id="deleting">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Deleting Files">
            <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Deleting Files</td>
                </tr>
                <tr align="left" valign="top" id="soft-delete">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>To remove outdated or unwanted files from the Media Server, click on the check boxes to the left of the file names, then click <strong>”Delete Selected"</strong> button. </p>
                    <center><img src={DeleteFile} alt="Delete File PopUp" width="450 " height="180" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
 
                    <p>When you select files/folders and click "Delete Selected", a confirmation popup appears explaining that items will be moved to a recoverable state instead of being permanently deleted. The popup informs you that deleted items can be restored within 30 days before automatic permanent removal. This replaces the previous hard delete behavior, ensuring your files are safely recoverable if deleted accidentally. Click <strong>“Delete”</strong> to proceed with the soft delete operation.</p>
                    <center><img src={SoftDeleteFilePopUp} alt="Soft Delete File PopUp"  width="600 " height="230"  hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="view-delete">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>A new "View deleted items" button is now available on the dashboard. This button allows you to access the list of soft-deleted files and folders in the current directory. The button is always visible when you have folder access, providing easy navigation to manage your deleted content. Click this button to switch from the main file view to the soft deleted items management interface.</p>
                    <center><img src={ViewSoftDeletedFiles} alt="View Soft Deleted Files" width="900 " height="auto" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="deleted-items-dashboard">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>The deleted items dashboard displays all soft-deleted files and folders in the current directory, showing details like name, size, deletion date, expiry date, and who deleted each item. Each row includes a "checkbox" that allows you to select and recover the item back to its original location in the main file listing. The dashboard shows items from all users who have deleted files in this folder, not just your own deletions. Use this view to manage and recover accidentally deleted content before the 30-day expiration period.</p>
                    <center><img src={DeletedItemsDashboard} alt="Deleted Items Dashboard" width="900 " height="auto" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="deleted-items-bulk-select">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>The deleted items dashboard includes checkboxes for bulk operations, allowing you to select multiple deleted items at once. After selecting the desired items using the checkboxes, click the "Restore" button to recover multiple files/folders simultaneously. This bulk restore feature saves time when you need to recover several items that were deleted together. The selection works similarly to the main dashboard, with "Select All" and "Clear All" options available.</p>
                    <center><img src={DeletedItemsBulkSelect} alt="Deleted Items Bulk Select" width="900 " height="auto" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="restore-confirmation">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>When you click "Restore" (single or bulk), a confirmation popup appears to verify your restore operation before proceeding. The popup lists the items you have selected for restoration and confirms they will be moved back to their original location in the main file listing. This confirmation step prevents accidental restores and provides one final review of which items will be recovered. Click "Restore" to complete the restoration process and return the items to active use.</p>
                    <center><img src={RestoreConfirmationPopup} alt="Restore Confirmation Popup" width="400 " height="180" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="restored-items-dashboard">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>After successful restoration, you will be automatically returned to the main dashboard where the restored items now appear in their original location. The items are immediately available for normal use - viewing, downloading, editing, or further file operations. A success notification confirms which items were restored successfully, and any SMS protection settings are automatically reapplied from when they were originally deleted. The restored files maintain their original names and properties exactly as they were before deletion.</p>
                    <center><img src={RestoredItemsDashboard} alt="Restored Items Dashboard" width="900 " height="auto" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="duplicate-soft-delete-popup">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>When uploading files, the system now checks for conflicts with both existing files and soft-deleted items in the same directory. If you try to upload files that match soft-deleted items, a separate overlay popup appears warning about the soft-deleted duplicates that cannot be uploaded or replaced. The main upload dialog continues to show existing files with "Replace Files" option, while soft-deleted conflicts are displayed separately. This prevents accidental overwrites and ensures you can restore deleted items safely without naming conflicts.</p>
                    <center><img src={DuplicateSoftDeletePopup} alt="Duplicate Soft Delete Popup" width="440 " height="270" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="cancel-only-popup">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>When your upload selection contains only files that match soft-deleted items (no existing files conflicts or uploadable files), the upload dialog shows only a "Cancel" button instead of the usual "Upload Files" button. This prevents confusion since no files can actually be uploaded in this scenario - all selected files conflict with soft-deleted items that need to be restored first. The system guides you to either cancel the upload or restore the conflicting deleted items before attempting to upload again. This ensures a clear user experience when all uploads are blocked by soft-delete conflicts.</p>
                    <center><img src={CancelOnlyPopup} alt="Cancel Only Popup" width="500 " height="300" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="rename-soft-deleted-conflict">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>When attempting to rename a file or folder to a name that matches an existing soft-deleted item in the same directory, the system prevents the rename operation and displays an error message. The error indicates that the target name already exists in the soft-deleted items list and cannot be used until that item is either restored or permanently purged. This protection ensures you don't accidentally create naming conflicts that would complicate future restore operations. You must choose a different name or restore/purge the conflicting soft-deleted item first.</p>
                    <center><img src={RenameSoftDeletedConflict} alt="Rename Soft Deleted Conflict" width="500 " height="200" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                <tr align="left" valign="top" id="bulk-rename-soft-deleted-conflict">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent"><p>During bulk rename operations, if any of the new names conflict with existing soft-deleted items, those specific rename operations will fail while others in the batch may succeed. The system processes each rename individually and provides detailed feedback about which renames succeeded and which failed due to soft-delete conflicts. Failed renames will show error messages indicating the conflicting soft-deleted item names, allowing you to adjust those specific names and retry. This granular approach ensures maximum success while protecting against soft-delete naming conflicts.</p>
                    <center><img src={BulkRenameSoftDeletedConflict} alt="Bulk Rename Soft Deleted Conflict" width="500 " height="200" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
            </table>
        </section>
 
        <span class="spacer"><br/><br/><br/></span>
 
 
        <section id="bulkrenaming">
            <table role="presentation" border="0" width="90%" cellspacing="1" cellpadding="2" align="center" summary="Renaming Files">
                <tr align="left" valign="top">
                    <td align="left" valign="top" class="helpSubHead" colspan="2">Bulk Renaming Files</td>
                </tr>
                <tr>
                    <td colspan="2"><h5>Access Bulk Rename</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">
                        <p>Click on the <strong>Bulk Rename</strong> icon located in the top menu bar alongside other action icons.</p>
                    <center><img src={HelpBulkrenameBtn} alt="Bulk Rename Icon" width="500 " height="80" hspace="0" vspace="0" border="0" align="absmiddle" /></center>                                                        
                    </td>
                </tr>
 
                <tr>
                    <td colspan="2"><h5>Open Bulk Rename Window</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                    <p>When you click the icon, a popup window will appear.
                        This window displays:Original file/folder names on the left.Editable fields on the right for renaming.</p>
                    <center><img src={HelpEditablePopup} alt="Editable Rename File PopUp" width="700 " height="350" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
 
                 <tr>
                    <td colspan="2"><h5>Edit File/Folder Names</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                     <p>In the editable fields, type the new names for files or folders.
                        As you start typing:
                        If the new name differs from the original, the background color will highlight the change for easy identification.
                        </p>
                        <p>Note : Folder/File name validations will be applicable for Bulk Rename as well</p>
                    <center><img src={HelpRenameHighlights} alt="Bulk Rename Highlights" width="700 " height="350" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
               
                    </td>
                </tr>
                <tr>
                     <td colspan="2"><h5>Review Changes</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                      <p>After editing all names, click the Bulk Rename button.
                        A confirmation popup will appear showing:
                        Original names vs New names side by side.
                        Review the changes carefully.</p>
                    <center><img src={HelpConfirmRename} alt="Bulk Rename COnfirm" width="700 " height="190" hspace="0" vspace="0" border="0" align="absmiddle" /></center>
                    </td>
                </tr>
               
                   <tr>
                     <td colspan="2"><h5>Confirm Rename</h5></td>
                </tr>
                <tr align="left" valign="top">
                    <td align="left" valign="top" width="2%">&nbsp;</td>
                    <td align="left" valign="top" class="helpContent">                    
                     <p>Click Confirm in the popup to apply the changes.
                        The system will rename all selected files/folders.
                        Once the rename process is complete, you will be redirected to the dashboard.
                        The updated file/folder names will be visible immediately.</p>
                    </td>
                </tr>              
                     
 
            </table>
        </section>
        <span class="spacer"><br/><br/></span>
        <Footer/>
        </body>
    </>
  )
}
 
export default MyHelp;